// src/config/features.js
// ─────────────────────────────────────────────
// Central feature flags — flip here, nowhere else.
// ─────────────────────────────────────────────

export const FEATURES = {
    // UI features
    ENABLE_BUS: true,
    AGENT_TEST: false,
    ENABLE_LEAD_BOT: true,
    // "Not getting confirmed tickets?" contact form (A/B: banner above tabs vs
    // "Contact us" button in result cards).
    // Day-to-day on/off and "Call us" hours come from the backend
    // (constants.py → intent "contact_lead_config", fetched once per route search).
    // This is a hard kill switch on top: false → no config call, no banner,
    // no card button, no modal, no A/B assignment and no contact_lead API calls.
    ENABLE_CONTACT_FORM: true,

    // ── Test / environment flags ──────────────────────────────────────────
    // Bus: true  → staging ETS  (https://staging.etravelsmart.in/etsAPI/api/)
    //      false → production ETS (https://agent.etravelsmart.com/etsAPI/api/)
    BUS_TEST: false,

    // Flight: true  → TBO test environment
    //         false → TBO production
    FLIGHT_TEST: false,

    // Route search WebSocket environment
    // "stage"      → wss://aluy1ihmkd.execute-api.ap-south-1.amazonaws.com/development?api_key=web_dev1
    // "production" → wss://h5nkqou4f7.execute-api.ap-south-1.amazonaws.com/production
    ROUTE_SEARCH_STAGE: "production",
};

// Derived WebSocket URL — import this in useTravelWebSocket.js
export const ROUTE_SEARCH_WS_URL =
    FEATURES.ROUTE_SEARCH_STAGE === "production"
        ? "wss://h5nkqou4f7.execute-api.ap-south-1.amazonaws.com/production"
        : "wss://aluy1ihmkd.execute-api.ap-south-1.amazonaws.com/development?api_key=web_dev1";
